import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  FeatureGroup,
  Polygon,
  Circle,
} from "react-leaflet";
import L from "leaflet";
import { EditControl } from "react-leaflet-draw";
import "leaflet/dist/leaflet.css";
import { useLeafletContext } from "@react-leaflet/core";
import "leaflet-draw/dist/leaflet.draw.css";
import { Modal, Spinner } from "react-bootstrap";

import swal from "sweetalert";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { useGetGTSurveyInspectionQuery } from "./RiskManagementApiSlice";
import { useGtPointCreateBoundaryMutation } from "./RiskManagementApiSlice";
import { faTruckField } from "@fortawesome/free-solid-svg-icons";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
const markerIcon = new L.Icon({
  iconUrl: require("./marker4.jpg"),
  iconSize: [24, 35],
  iconAnchor: [22, 94],
  popupAnchor: [-3, -76],
  shadowSize: [20, 25],
  shadowAnchor: [22, 94],
});

function getBounds(props) {
  return L.latLng(props.center).toBounds(props.size);
}
function Square(props) {
  const context = useLeafletContext();
  const squareRef = useRef();
  const propsRef = useRef(props);

  useEffect(() => {
    squareRef.current = new L.Rectangle(getBounds(props));
    const container = context.layerContainer || context.map;
    container.addLayer(squareRef.current);

    return () => {
      container.removeLayer(squareRef.current);
    };
  }, []);

  useEffect(() => {
    if (
      props.center !== propsRef.current.center ||
      props.size !== propsRef.current.size
    ) {
      squareRef.current.setBounds(getBounds(props));
    }

    if (props.bounds.length >= 1) {
      context.map.fitBounds(props.bounds);
    }
    propsRef.current = props;
  }, [props.center, props.size, props.bounds]);

  return null;
}

const RiskManagementGtPointCreateBoundary = ({
  latLongData,
  listData,
  refetch,
  handleClose,
  otherMedia,
}) => {
  const [PlotsMarker, setPlotsMarker] = useState([]);
  const [showPlots, setPlotsBounds] = useState([]);
  const [dataPoints, MetadataPoints] = useState([]);
  console.log("latLongData",latLongData)
  const [latdata, setlatdata] = useState([]);

  const [plot_boundary, setMapLayers] = useState([]);
  const [disableButton, disableSubmitBtn] = useState(false);

  const [boundaryExist, setBoundaryExist] = useState([]);

  const [center, setCenter] = useState([28.5769735, 77.317138]);
  const [
    updateBoundary,
    updateFarmResponse,
  ] = useGtPointCreateBoundaryMutation();

  const [lightBoxViewImage, setImageInLightbox] = useState("");
  const [openLightbox, setOpenLightBox] = useState(false);
  const fillBlueOptions = { fillColor: "blue" };
  const [SortedArray, setSortedArray] = useState([]);
  const [polygonData, setPolygonData] = useState([]);

  useEffect(() => {
    var tempPlots = [];
    if (Array.isArray(latLongData)) {
      setlatdata(latLongData);
      latLongData.map((item) => {
        if (item.lat && item.long) {
          tempPlots.push([item.lat, item.long]);
        }
      });
      setPlotsBounds(tempPlots);
    }
    if (JSON.stringify(listData.FieldBoundaryMarking) !== `{}`) {
      setBoundaryExist(listData.FieldBoundaryMarking);
    } else if (otherMedia?.length > 0) {
      const sortedData = [...otherMedia]?.sort(function(a, b) {
        const attributeA = parseInt(a.Attribute.split("-")[1].trim());
        const attributeB = parseInt(b.Attribute.split("-")[1].trim());

        return attributeA - attributeB;
      });

      setSortedArray(otherMedia);

      var array = [];
      sortedData?.map((item) => {
        array.push([item.Metadata.latitude, item.Metadata.longitude]);
      });
      setPolygonData(array);
    } else if (JSON.stringify(listData.FarmBoundaryVerified) !== `{}`) {
      setBoundaryExist(listData.FarmBoundaryVerified);
    } else if (
      JSON.stringify(listData.FarmBoundaryVerified) === `{}` &&
      JSON.stringify(listData.FarmBoundaryTagging) !== `{}`
    ) {
      setBoundaryExist(listData.FarmBoundaryTagging);

      if (listData.Media) {
        var latlongArray = [];
        var latlongObj = { latitude: "", longitude: "", image: "" };
        listData.Media.map((item, index) => {
          if (index != 0) {
            if (item.Metadata !== "") {
              if (item.Metadata.latitude && item.Metadata.longitude) {
                latlongObj = {
                  latitude: item.Metadata.latitude,
                  longitude: item.Metadata.longitude,
                  image: item.ImagePath,
                };
                latlongArray.push(latlongObj);
              }
            }
          }
        });
        MetadataPoints(latlongArray);
      }
    }
  }, [latLongData, listData, otherMedia]);

  const ZOOM_LEVEL = 6;
  const customMarkerIcon = L.icon({
    iconUrl: require("./marker4.jpg"), // Replace with your marker icon URL
    iconSize: [24, 35], // Icon size
    iconAnchor: [12, 35], // Icon anchor
  });

  const _onCreate = (e) => {
    const { layerType, layer } = e;

    if (layerType === "polygon") {
      const { _leaflet_id } = layer;
      setMapLayers({ boundary: layer.getLatLngs()[0] });
    }
    if (layerType === "marker") {
      const { _leaflet_id } = layer;
      const latlng = layer.getLatLng();
    }
  };

  function convert_lat_long(data) {
    let arr = [];

    for (var i = 0; i < data.plot_boundary.boundary.length; i++) {
      arr.push({
        lat: data.plot_boundary.boundary[i].lat,
        long: data.plot_boundary.boundary[i].lng,
      });
    }
    return arr;
  }
  const handleSubmit = (e) => {
    const updatedboundary = { plot_boundary };
    let coord = convert_lat_long(updatedboundary);
    let boundary_ = "";
    if (otherMedia.length > 0) {
      boundary_ = { FieldBoundaryMarking: coord };
    } else {
      boundary_ = { FarmBoundaryVerified: coord };
    }
    disableSubmitBtn(faTruckField);
    updateBoundary({ id: listData.Id, payload: boundary_ })
      .unwrap()
      .then((data) => {
        swal("Boundary Created Successfully", {
          buttons: false,
          icon: "success",
          title: "Successfully Created Boundary",
          timer: 1500,
        });
        handleClose(false);
        refetch();
        disableSubmitBtn(false);
      })
      .catch((error) => {
        toast.error("Error while Creating Boundary");
        disableSubmitBtn(false);

        return;
      });
  };

  const showLargeImage = (image) => {
    setImageInLightbox(image);
    setOpenLightBox(true);
  };

  return (
    <>
      <div className="row mt-3">
        <div className="col text-center">
          <div className="col">
            <MapContainer
              center={center}
              zoom={ZOOM_LEVEL}
              style={{ height: "50vh", width: "100%" }}
            >
              <FeatureGroup>
                <EditControl
                  position="topright"
                  onCreated={_onCreate}
                  draw={{
                    rectangle: false,
                    polyline: false,
                    circle: false,
                    circlemarker: false,
                    marker: {
                      icon: customMarkerIcon,
                    },
                  }}
                />
              </FeatureGroup>
              <TileLayer
                url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}"
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              />
              <Square center={center} size={0} bounds={showPlots} />
              {polygonData.length > 0 ? (
                <>
                  <Polygon color="red" positions={polygonData} />
                  {SortedArray?.map((item, index) => {
                    return (
                      <Circle
                        center={[
                          item.Metadata.latitude,
                          item.Metadata.longitude,
                        ]}
                        pathOptions={fillBlueOptions}
                        radius={2.5}
                      >
                        <Popup>
                          {item.Attribute}
                          <div>Latitude:{item.Metadata.latitude}</div>
                          <div>Longitude :{item.Metadata.longitude}</div>
                          &nbsp;{" "}
                          <img
                            src={item.image}
                            width="20px"
                            className="cursor-pointer"
                            onClick={(e) => showLargeImage(item.image)}
                          />
                        </Popup>
                      </Circle>
                    );
                  })}
                </>
              ) : boundaryExist.length !== 0 && dataPoints.length > 0 ? (
                <>
                  <Polygon color="red" positions={boundaryExist.coordinates} />
                  {dataPoints.map((item, index) => {
                    return (
                      <Circle
                        center={[item.latitude, item.longitude]}
                        pathOptions={fillBlueOptions}
                        radius={2.5}
                      >
                        <Popup>
                          Corner {index + 1}
                          &nbsp;{" "}
                          <img
                            src={item.image}
                            width="20px"
                            className="cursor-pointer"
                            onClick={(e) => showLargeImage(item.image)}
                          />
                        </Popup>
                      </Circle>
                    );
                  })}
                </>
              ) : boundaryExist.length !== 0 && dataPoints.length === 0 ? (
                <Polygon color="red" positions={boundaryExist.coordinates} />
              ) : (
                latLongData?.map((item) => {
                  return (
                    <Marker
                      position={[item.lat, item.long]}
                      icon={markerIcon}
                    ></Marker>
                  );
                })
              )}
              {openLightbox ? (
                <Lightbox
                  image={lightBoxViewImage}
                  title="Image Title"
                  onClose={() => setOpenLightBox(false)}
                />
              ) : (
                ""
              )}
            </MapContainer>
            <div className="text-center">
              <button
                type="submit"
                className="btn btn-warning  mt-4 mx-3 "
                onClick={() => handleSubmit()}
              >
                Save Boundary
                {disableButton ? <Spinner animation="border" size="sm" /> : ""}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RiskManagementGtPointCreateBoundary;
